import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
//Language
import { useIntl } from "react-intl";

import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
//Actions
import {
    showRawDataModalHide
} from 'Redux/actions';

import { copyToClipboard } from 'Core/data/Helpers';

//Styles
import "./showRawData.scss";

const ShowRawData = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //redux states
    const openModal = useSelector(state => state.showRawDataRedux.openModal);

    const closeModal = () => {
        dispatch(showRawDataModalHide());
    }

    return (
        <Modal
            open={openModal}
            title={messages['show_raw_data_modal_title']}
            position="right"
            size="small"
            handleClose={() => closeModal()}
        >
            <ModalBody>
                <div style={{ marginBottom: 30 }}>
                    <JsonView data={props.rawData} shouldExpandNode={allExpanded} style={defaultStyles} />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={(e) => {
                        copyToClipboard(JSON.stringify(props.rawData), messages['common_copied'])
                    }}
                >
                    {messages['show_raw_data_modal_copy']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={(e) => {
                        closeModal();
                    }}
                >
                    {messages['common_cancel']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default ShowRawData;